import React, { useState, useRef, useEffect } from "react";
import { Button,  TextField } from "../../components/elements";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import Select from "react-select";
import SearchIcon from "../../assets/images/OutletImages/searchicon.svg";
import BlackCrossicon from "../../assets/images/OutletImages/BlackCrossIconModals.svg";
import Crossicon from "../../assets/images/OutletImages/WhiteCrossIcon.svg";
import EmptyState from "../../assets/images/EmptySearchPNGDataRoom.png";
import {
  getAllOrganizationApi,
  getAllTrailRejectedApi,
  getAllTrailRequestedApi,
  validateEncryptedStringForOrganizationTrialEmailApi,
} from "../../store/Actions/ViewOrganizationActions";
import "./ViewOrganizations.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { viewOrganizationLoader } from "../../store/ActionsSlicers/ViewOrganizationActionSlicer";
import { formatDate } from "../../common/functions/dateFormatters";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_ar from "react-date-object/locales/gregorian_ar";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { resetResponseMessage } from "../../store/ActionsSlicers/GlobalAdminDasboardSlicer";
import CurrenrOrganization from "./CurrentOrganizations/CurrentOrganizations";
import TrailRequest from "./TrailRequest/TrailRequest";
import RejectedRequest from "./RejectedRequest/RejectedRequest";
import { useViewOrganization } from "../../context/viewOrganizations";
import { showNotification } from "../../components/elements/snack_bar/snackbar";

const ViewOrganization = () => {
  const {
    searchOrganizationData,
    setSearchOrganizationData,
    setShowSearchText,
    showsearchText,
    setAppliedSearchFilters,
    appliedSearchFilters,
  } = useViewOrganization();
  console.log(
    appliedSearchFilters,
    "appliedSearchFiltersappliedSearchFiltersappliedSearchFilters"
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const calendRef = useRef();
  const [currentTab, setCurrentTab] = useState(1);

  // current language set in local storage
  let currentLanguage = localStorage.getItem("currentLanguage");

  // for response message
  const Responsemessage = useSelector(
    (state) => state.searchOrganization.Responsemessage
  );

  // reducer for get All Organization but in dropdown
  const organizationIdDataDropdown = useSelector(
    (state) => state.globalAdminDashboardReducer.getOrganizationNames
  );

  const [searchBox, setSearchBox] = useState(false);
  const [organizationDataValue, setOrganizationDataValue] = useState(null);

  // state for view Organizer Table data

  // for dropdown lazy loading state:
  const [organization, setOrganization] = useState([]);

  // states for search
  const [isFound, setIsFound] = useState(true);
  const [isScroll, setIsScroll] = useState(false);
  const [calendarValue, setCalendarValue] = useState(gregorian);
  const [localValue, setLocalValue] = useState(gregorian_en);
  let orgTrialAccept = localStorage.getItem("orgTrialAccept_action");
  let orgTrialReject = localStorage.getItem("orgTrialReject_action");
  console.log(isFound, "isFoundisFoundisFound");


  const callSearchApi = (filters) => {
    if (currentTab === 1) {
      const newData = {
        OrganizationContactName: filters.OrganizationContactName || "",
        OrganizationContactEmail: filters.OrganizationContactEmail || "",
        OrganizationDateFrom: filters.OrganizationDateFrom
          ? `${filters.OrganizationDateFrom}000000`
          : "",
        OrganizationDateTo: filters.OrganizationDateTo
          ? `${filters.OrganizationDateTo}000000`
          : "",
        OrganizationSubscriptionStatus: Number(
          filters.OrganizationSubscriptionStatus?.value || 0
        ),
        OrganizationName: filters.OrganizationName || "",
        sRow: 0,
        eRow: 10,
      };

      dispatch(viewOrganizationLoader(true));
      dispatch(getAllOrganizationApi({ newData, navigate, t, setIsFound }));
    }

    if (currentTab === 2) {
      dispatch(
        getAllTrailRequestedApi({
          newData: {
            OrganizationName: filters.OrganizationName || "",
            ContactPersonName: filters.OrganizationContactName || "",
            ContactPersonEmail: filters.OrganizationContactEmail || "",
            DateTimeFrom: filters.OrganizationDateFrom
              ? `${filters.OrganizationDateFrom}000000`
              : "",
            DateTimeTo: filters.OrganizationDateTo
              ? `${filters.OrganizationDateTo}000000`
              : "",
            SkipRows: 0,
            Length: 10,
          },
          navigate,
          t,
        })
      );
    }

    if (currentTab === 3) {
      dispatch(
        getAllTrailRejectedApi({
          newData: {
            OrganizationName: filters.OrganizationName || "",
            ContactPersonName: filters.OrganizationContactName || "",
            ContactPersonEmail: filters.OrganizationContactEmail || "",
            DateTimeFrom: filters.OrganizationDateFrom
              ? `${filters.OrganizationDateFrom}000000`
              : "",
            DateTimeTo: filters.OrganizationDateTo
              ? `${filters.OrganizationDateTo}000000`
              : "",
            SkipRows: 0,
            Length: 10,
          },
          navigate,
          t,
        })
      );
    }
  };

  useEffect(() => {
    if (
      Responsemessage &&
      Responsemessage !== t("No-data-available") &&
      Responsemessage !== "" &&
      Responsemessage !== "No Data available"
    ) {
      // Show notification
      showNotification("success", Responsemessage);
  
      // Reset the response message in the store
      dispatch(resetResponseMessage());
    }
  }, [Responsemessage, dispatch, t]);

  //Calling Organization Api
  useEffect(() => {
    if (
      localStorage.getItem("orgTrialReject_action") !== null ||
      localStorage.getItem("orgTrialAccept_action") !== null
    ) {
      let Data = { EncryptedString: orgTrialAccept || orgTrialReject };
      dispatch(
        validateEncryptedStringForOrganizationTrialEmailApi({
          Data,
          navigate,
          t,
          setCurrentTab,
        })
      );
    } else {
      setCurrentTab(1);
    }

    return () => {
      setSearchOrganizationData({
        OrganizationContactName: "",
        OrganizationContactEmail: "",
        OrganizationDateFrom: "",
        OrganizationDateTo: "",
        OrganizationName: "",
        OrganizationSubscriptionStatus: {
          value: 0,
          label: "",
        },
        OrganizationDateToView: "",
        OrganizationDateFromView: "",
      });
    };
  }, []);

  // useEffect for dropdown select organization Names
  useEffect(() => {
    if (
      organizationIdDataDropdown !== null &&
      organizationIdDataDropdown !== undefined &&
      organizationIdDataDropdown?.result?.organizations.length > 0
    ) {
      setOrganization(organizationIdDataDropdown.result.organizations);
    } else {
      setOrganization([]);
    }
  }, [organizationIdDataDropdown]);

  // for status Options
  const options = [
    { value: 1, label: "Active" },
    { value: 2, label: "InActive" },
    { value: 3, label: "suspended" },
    { value: 4, label: "Closed" },
    { value: 5, label: "Terminated Requested" },
    { value: 6, label: "Deleted" },
    { value: 7, label: "Archived" },
    { value: 8, label: "Locked By Global Admin" },
  ];

  // useEffect to set currentLanguag
  useEffect(() => {
    if (currentLanguage !== undefined && currentLanguage !== null) {
      if (currentLanguage === "en") {
        setCalendarValue(gregorian);
        setLocalValue(gregorian_en);
      } else if (currentLanguage === "ar") {
        setCalendarValue(gregorian);
        setLocalValue(gregorian_ar);
      }
    }
  }, [currentLanguage]);

  // onChange handler for Status dropdown
  const handleStatusChange = (selectedOption) => {
    setSearchOrganizationData((prevState) => ({
      ...prevState,
      OrganizationSubscriptionStatus: selectedOption,
    }));
  };

  // onChange Handler for organizer Dropdown
  const organizerChangeHandler = (selectedOrganizer) => {
    setOrganizationDataValue(selectedOrganizer);
    setSearchOrganizationData({
      ...searchOrganizationData,
      OrganizationName: selectedOrganizer.label,
    });
  };
  //onChange for View Orgniazation Search
  const searchViewOrganizationHandler = (event) => {
    const { name, value } = event.target;
    if (name === "OrganizationContactName") {
      setSearchOrganizationData({
        ...searchOrganizationData,
        OrganizationContactName: value,
      });
    } else if (name === "OrganizationContactEmail") {
      setSearchOrganizationData({
        ...searchOrganizationData,
        OrganizationContactEmail: value,
      });
    }
  };

  // to open search box handler
  const HandleopenSearchBox = () => {
    setSearchOrganizationData({
      ...searchOrganizationData,
      OrganizationContactName: searchOrganizationData.OrganizationContactName,
      OrganizationContactEmail: searchOrganizationData.OrganizationContactEmail,
      OrganizationDateFrom: searchOrganizationData.OrganizationDateFrom,
      OrganizationDateTo: searchOrganizationData.OrganizationDateTo,
      OrganizationDateToView: searchOrganizationData.OrganizationDateToView,
      OrganizationDateFromView: searchOrganizationData.OrganizationDateFromView,
      OrganizationSubscriptionStatus: {
        value: searchOrganizationData.OrganizationSubscriptionStatus.value,
        label: searchOrganizationData.OrganizationSubscriptionStatus.label,
      },
    });
    setSearchBox(!searchBox);
  };

  // handler searched button
  const handleSearches = (fieldName) => {
    let updatedData = { ...searchOrganizationData };
    if (fieldName === "OrganizationContactName") {
      updatedData.OrganizationContactName = "";
    } else if (fieldName === "OrganizationContactEmail") {
      updatedData.OrganizationContactEmail = "";
    } else if (fieldName === "OrganizationDateFrom") {
      updatedData.OrganizationDateFrom = "";
      updatedData.OrganizationDateFromView = "";
    } else if (fieldName === "OrganizationDateTo") {
      updatedData.OrganizationDateTo = "";
      updatedData.OrganizationDateToView = "";
    } else if (fieldName === "TotalActiveSubscription") {
      updatedData.OrganizationSubscriptionStatus = { value: 0, label: "" };
    } else if (fieldName === "OrganizationName") {
      updatedData.OrganizationName = "";
    }

    console.log(updatedData, "updatedDataupdatedDataupdatedData");
    if (
      updatedData.OrganizationContactEmail === "" &&
      updatedData.OrganizationContactName === "" &&
      updatedData.OrganizationDateFrom === "" &&
      updatedData.OrganizationDateFromView === "" &&
      updatedData.OrganizationDateTo === "" &&
      updatedData.OrganizationDateToView === "" &&
      updatedData.OrganizationSubscriptionStatus.value === 0 &&
      updatedData.OrganizationName === ""
    ) {
      setShowSearchText(false);
    }
    setShowSearchText(true);
    setSearchOrganizationData(updatedData);
    // Clear the current data before fetching new data

    if (currentTab === 1) {
      let newData = {
        OrganizationContactName: updatedData.OrganizationContactName,
        OrganizationContactEmail: updatedData.OrganizationContactEmail,
        OrganizationDateTo: updatedData.OrganizationDateTo
          ? `${updatedData.OrganizationDateTo}000000`
          : "",
        OrganizationDateFrom: updatedData.OrganizationDateFrom
          ? `${updatedData.OrganizationDateFrom}000000`
          : "",
        OrganizationSubscriptionStatus: Number(
          updatedData.OrganizationSubscriptionStatus.value
        ),
        OrganizationName: updatedData.OrganizationName,
        sRow: 0,
        eRow: 10,
      };
      setIsFound(true);
      dispatch(viewOrganizationLoader(true));
      dispatch(getAllOrganizationApi({ newData, navigate, t, setIsFound }));
      setIsScroll(false);

      // setSearchBox(false);
      // setShowSearchText(false);
      setSearchOrganizationData(updatedData);
    } else if (currentTab === 2) {
      let newData = {
        OrganizationName: updatedData.OrganizationName,
        ContactPersonName: updatedData.OrganizationContactName,
        ContactPersonEmail: updatedData.OrganizationContactEmail,
        DateTimeTo: updatedData.OrganizationDateTo
          ? `${updatedData.OrganizationDateTo}000000`
          : "",
        DateTimeFrom: updatedData.OrganizationDateFrom
          ? `${updatedData.OrganizationDateFrom}000000`
          : "",
        SkipRows: 0,
        Length: 10,
      };
      dispatch(viewOrganizationLoader(true));
      dispatch(getAllTrailRequestedApi({ newData, navigate, t }));
      setIsScroll(false);

      // setSearchBox(false);
      // setShowSearchText(false);
      setSearchOrganizationData(updatedData);
    } else if (currentTab === 3) {
      let newData = {
        OrganizationName: updatedData.OrganizationName,
        ContactPersonName: updatedData.OrganizationContactName,
        ContactPersonEmail: updatedData.OrganizationContactEmail,
        DateTimeTo: updatedData.OrganizationDateTo
          ? `${updatedData.OrganizationDateTo}000000`
          : "",
        DateTimeFrom: updatedData.OrganizationDateFrom
          ? `${updatedData.OrganizationDateFrom}000000`
          : "",
        SkipRows: 0,
        Length: 10,
      };
      dispatch(viewOrganizationLoader(true));
      dispatch(getAllTrailRejectedApi({ newData, navigate, t }));
      setIsScroll(false);

      // setSearchBox(false);
      // setShowSearchText(false);
      setSearchOrganizationData(updatedData);
      setAppliedSearchFilters({
        ...searchOrganizationData,
      });
    }
  };

  // search Button Handler
  const handleSearchButton = () => {
    setAppliedSearchFilters({ ...searchOrganizationData });
    setShowSearchText(true);
    setSearchBox(false);
    setIsScroll(false);

    callSearchApi(searchOrganizationData);
  };

  // to reset field on handler reset button
  const handleResetButton = () => {
    const resetState = {
      OrganizationContactName: "",
      OrganizationContactEmail: "",
      OrganizationDateFrom: "",
      OrganizationDateTo: "",
      OrganizationName: "",
      OrganizationSubscriptionStatus: { value: 0, label: "" },
      OrganizationDateToView: "",
      OrganizationDateFromView: "",
    };

    setOrganizationDataValue(null);
    setSearchBox(false);
    setShowSearchText(false);
    setIsScroll(false);

    setSearchOrganizationData(resetState);
    setAppliedSearchFilters({});

    callSearchApi(resetState);
  };

  const handleCancelSearchbox = () => {
    setSearchBox(false);
  };

  // date handler fromDate
  //onChange Date from
  const handleChangeFromDate = (date) => {
    if (date) {
      let getDate = new Date(date);
      let utcDate = getDate.toISOString().slice(0, 10).replace(/-/g, "");
      setSearchOrganizationData((prevData) => ({
        ...prevData,
        OrganizationDateFrom: utcDate,
        OrganizationDateFromView: getDate,
      }));
    } else {
      setSearchOrganizationData((prevData) => ({
        ...prevData,
        OrganizationDateFrom: "",
        OrganizationDateFromView: "",
      }));
    }
  };

  const handleChangeToDate = (date) => {
    if (date) {
      let getDate = new Date(date);
      let utcDate = getDate.toISOString().slice(0, 10).replace(/-/g, "");
      setSearchOrganizationData((prevData) => ({
        ...prevData,
        OrganizationDateTo: utcDate,
        OrganizationDateToView: getDate,
      }));
    } else {
      setSearchOrganizationData((prevData) => ({
        ...prevData,
        OrganizationDateTo: "",
        OrganizationDateToView: "",
      }));
    }
  };

  const onChangeEventForSearch = (e) => {
    setSearchOrganizationData({
      ...searchOrganizationData,
      OrganizationName: e.target.value.trimStart(),
    });
  };

  const handleKeyDownSearch = (e) => {
    if (e.key === "Enter") {
      if (searchOrganizationData.OrganizationName !== "") {
        if (currentTab === 1) {
          // Current Organizations
          let newData = {
            OrganizationContactName: "",
            OrganizationContactEmail: "",
            OrganizationDateTo: "",
            OrganizationDateFrom: "",
            OrganizationSubscriptionStatus: 0,
            OrganizationName: searchOrganizationData.OrganizationName,
            sRow: 0,
            eRow: 10,
          };
          dispatch(viewOrganizationLoader(true));
          dispatch(getAllOrganizationApi({ newData, navigate, t, setIsFound }));
        } else if (currentTab === 2) {
          // Trail Requests
          let newData = {
            OrganizationName: searchOrganizationData.OrganizationName,
            ContactPersonName: "",
            ContactPersonEmail: "",
            DateTimeTo: "",
            DateTimeFrom: "",
            SkipRows: 0,
            Length: 10,
          };
          dispatch(viewOrganizationLoader(true));
          dispatch(getAllTrailRequestedApi({ newData, navigate, t }));
        } else if (currentTab === 3) {
          // Rejected Requests
          let newData = {
            OrganizationName: searchOrganizationData.OrganizationName,
            ContactPersonName: "",
            ContactPersonEmail: "",
            DateTimeTo: "",
            DateTimeFrom: "",
            SkipRows: 0,
            Length: 10,
          };
          dispatch(viewOrganizationLoader(true));
          dispatch(getAllTrailRejectedApi({ newData, navigate, t }));
        }
      }
      setShowSearchText(true);
      setAppliedSearchFilters({
        ...searchOrganizationData,
      });
    }
  };

  const handleClickTab = (value) => {
    setIsScroll(false);
    setCurrentTab(value);
    setShowSearchText(false);
    setSearchOrganizationData({
      OrganizationContactName: "",
      OrganizationContactEmail: "",
      OrganizationDateFrom: "",
      OrganizationDateTo: "",
      OrganizationName: "",
      OrganizationSubscriptionStatus: {
        value: 0,
        label: "",
      },
      OrganizationDateToView: "",
      OrganizationDateFromView: "",
    });
    setAppliedSearchFilters({
        ...searchOrganizationData,
        OrganizationName:""
      });
    if (value === 1) {
      // Current Organizations

      setIsScroll(false);
    } else if (value === 2) {
      // Trail Requests
      let newData = {
        OrganizationName: "",
        ContactPersonName: "",
        ContactPersonEmail: "",
        DateTimeTo: "",
        DateTimeFrom: "",
        SkipRows: 0,
        Length: 10,
      };
      dispatch(viewOrganizationLoader(true));
      dispatch(getAllTrailRequestedApi({ newData, navigate, t }));
      setIsScroll(false);
    } else {
      // Rejected Requests
      let newData = {
        OrganizationName: "",
        ContactPersonName: "",
        ContactPersonEmail: "",
        DateTimeTo: "",
        DateTimeFrom: "",
        SkipRows: 0,
        Length: 10,
      };
      dispatch(viewOrganizationLoader(true));
      dispatch(getAllTrailRejectedApi({ newData, navigate, t }));
      setIsScroll(false);
    }
  };

  const handleRemoveFilter = (key) => {
    // 1️⃣ Update applied filters (chips)
    const updatedFilters = { ...appliedSearchFilters };
    delete updatedFilters[key];

    // 2️⃣ Update search state (API source)
    const updatedSearchData = {
      ...searchOrganizationData,
      [key]:
        key === "OrganizationSubscriptionStatus" ? { value: 0, label: "" } : "",
    };

    setAppliedSearchFilters(updatedFilters);
    setSearchOrganizationData(updatedSearchData);

    // 3️⃣ CALL API with empty value
    setShowSearchText(Object.keys(updatedFilters).length > 0);
    setIsScroll(false);

    callSearchApi(updatedSearchData);
  };

  return (
    <>
      <Row className="mt-3">
        <Col lg={7} md={7} sm={7}>
          <span className={"HeadingViewORganization"}>
            {t("View-organization")}
          </span>
        </Col>
        <Col lg={5} md={5} sm={5}>
          <span className="position-relative">
            <TextField
              onKeyDown={handleKeyDownSearch}
              change={onChangeEventForSearch}
              placeholder={t("Search-organizations")}
              value={searchOrganizationData.OrganizationName}
              name={"organizationName"}
              labelClass={"d-none"}
              applyClass={
                searchBox ? "NewMeetingFileds_boxOpen" : "NewMeetingFileds"
              }
              inputicon={
                <>
                  <Row>
                    <Col
                      lg={12}
                      md={12}
                      sm={12}
                      className="d-flex gap-2 align-items-center"
                    >
                      <img
                        src={SearchIcon}
                        alt=""
                        className={"Search_Bar_icon_class"}
                        draggable="false"
                        onClick={HandleopenSearchBox}
                      />
                    </Col>
                  </Row>
                </>
              }
              iconClassName={"d-block"}
            />
            <div className="d-flex gap-2 flex-wrap mt-2">
              {Object.entries(appliedSearchFilters).map(([key, value]) => {
                if (
                  !value ||
                  value === "" ||
                  (typeof value === "object" && value.value === 0)
                )
                  return null;

                const label =
                  key === "OrganizationSubscriptionStatus"
                    ? value.label
                    : value;

                return (
                  <div key={key} className="SearchablesItems">
                    <span className="Searches">{label}</span>
                    <img
                      src={BlackCrossicon}
                      className="CrossIcon_Class"
                      onClick={() => handleRemoveFilter(key)}
                    />
                  </div>
                );
              })}
            </div>
            {/* <Row>
              <Col lg={12} md={12} sm={12} className="d-flex gap-2 flex-wrap">
                {showsearchText &&
                searchOrganizationData.OrganizationName !== "" ? (
                  <div className={"SearchablesItems"}>
                    <span className={"Searches"}>
                      {searchOrganizationData.OrganizationName}
                    </span>
                    <img
                      src={Crossicon}
                      alt=""
                      className={"CrossIcon_Class"}
                      width={13}
                      onClick={() => handleSearches("OrganizationName")}
                    />
                  </div>
                ) : null}
                {showsearchText &&
                  searchOrganizationData.OrganizationContactName && (
                    <div className={"SearchablesItems"}>
                      <span className={"Searches"}>
                        {searchOrganizationData.OrganizationContactName}
                      </span>
                      <img
                        src={Crossicon}
                        alt=""
                        className={"CrossIcon_Class"}
                        width={13}
                        onClick={() =>
                          handleSearches("OrganizationContactName")
                        }
                      />
                    </div>
                  )}

                {showsearchText &&
                searchOrganizationData.OrganizationContactEmail !== "" ? (
                  <div className={"SearchablesItems"}>
                    <span className={"Searches"}>
                      {searchOrganizationData.OrganizationContactEmail}
                    </span>
                    <img
                      src={Crossicon}
                      alt=""
                      className={"CrossIcon_Class"}
                      width={13}
                      onClick={() => handleSearches("OrganizationContactEmail")}
                    />
                  </div>
                ) : null}

                {showsearchText &&
                  searchOrganizationData.OrganizationDateFrom && (
                    <div className={"SearchablesItems"}>
                      <span className={"Searches"}>
                        {formatDate(
                          searchOrganizationData.OrganizationDateFrom,
                          currentLanguage
                        )}
                      </span>
                      <img
                        src={Crossicon}
                        alt=""
                        className={"CrossIcon_Class"}
                        width={13}
                        onClick={() => handleSearches("OrganizationDateFrom")}
                      />
                    </div>
                  )}

                {showsearchText &&
                  searchOrganizationData.OrganizationDateTo && (
                    <div className={"SearchablesItems"}>
                      <span className={"Searches"}>
                        {formatDate(
                          searchOrganizationData.OrganizationDateTo,
                          currentLanguage
                        )}
                      </span>
                      <img
                        src={Crossicon}
                        alt=""
                        className={"CrossIcon_Class"}
                        width={13}
                        onClick={() => handleSearches("OrganizationDateTo")}
                      />
                    </div>
                  )}

                {/* {showsearchText && organizationDataValue && (
                  <div className='SearchablesItems'>
                    <span className='Searches'>
                      {organizationDataValue.label}
                    </span>
                    <img
                      src={Crossicon}
                      alt=''
                      className='CrossIcon_Class'
                      width={13}
                      onClick={() => handleSearches("organizationName")}
                    />
                  </div>
                )} */}
            {/* {showsearchText &&
                  searchOrganizationData.OrganizationSubscriptionStatus
                    .label && (
                    <div className={"SearchablesItems"}>
                      <span className={"Searches"}>
                        {
                          searchOrganizationData.OrganizationSubscriptionStatus
                            .label
                        }
                      </span>
                      <img
                        src={Crossicon}
                        alt=""
                        className={"CrossIcon_Class"}
                        width={13}
                        onClick={() =>
                          handleSearches("TotalActiveSubscription")
                        }
                      />
                    </div>
                  )} */}
            {/* </Col> */}
            {/* </Row> */}
            {searchBox ? (
              <>
                <Row>
                  <Col lg={12} md={12} sm={12} className={"SearchBox"}>
                    <Row className="mt-2">
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        className="d-flex justify-content-end align-items-center"
                      >
                        <img
                          alt=""
                          src={BlackCrossicon}
                          draggable="false"
                          className={"CrossIcon_Class"}
                          onClick={handleCancelSearchbox}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col lg={6} md={6} sm={6}>
                        <TextField
                          labelClass={"d-none"}
                          value={searchOrganizationData.OrganizationContactName}
                          name={"OrganizationContactName"}
                          applyClass={"SearchTextFiled"}
                          placeholder={t("Admin-name")}
                          change={searchViewOrganizationHandler}
                        />
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <TextField
                          labelClass={"d-none"}
                          name={"OrganizationContactEmail"}
                          applyClass={"SearchTextFiled"}
                          placeholder={t("Admin-email")}
                          value={
                            searchOrganizationData.OrganizationContactEmail
                          }
                          change={searchViewOrganizationHandler}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col lg={6} md={6} sm={6}>
                        <DatePicker
                          value={
                            searchOrganizationData.OrganizationDateFromView
                          }
                          format={"MMM DD, YYYY"}
                          placeholder={t("Date-From")}
                          render={
                            <InputIcon
                              placeholder={t("Date-from")}
                              className={"UserLoginHistory_datePicker"}
                            />
                          }
                          editable={false}
                          className="datePickerTodoCreate2"
                          containerClassName={"datePicker_Container"}
                          onOpenPickNewDate={false}
                          inputMode=""
                          calendar={calendarValue}
                          locale={localValue}
                          ref={calendRef}
                          onChange={handleChangeFromDate}
                        />
                      </Col>
                      <Col lg={6} md={6} sm={6}>
                        <DatePicker
                          value={searchOrganizationData.OrganizationDateToView}
                          format={"MMM DD, YYYY"}
                          placeholder={t("Date-to")}
                          render={
                            <InputIcon
                              placeholder={t("Date-to")}
                              className={"UserLoginHistory_datePicker"}
                            />
                          }
                          editable={false}
                          className="datePickerTodoCreate2"
                          containerClassName={"datePicker_Container"}
                          onOpenPickNewDate={false}
                          inputMode=""
                          calendar={calendarValue}
                          locale={localValue}
                          ref={calendRef}
                          onChange={handleChangeToDate}
                        />
                      </Col>
                    </Row>

                    {currentTab === 1 && (
                      <Row className="mt-3">
                        <Col lg={6} md={6} sm={6}>
                          <Select
                            value={
                              searchOrganizationData
                                .OrganizationSubscriptionStatus?.value !== 0
                                ? searchOrganizationData.OrganizationSubscriptionStatus
                                : null
                            }
                            styles={{
                              placeholder: (provided) => ({
                                ...provided,
                                fontSize: "12px",
                                fontWeight: 500,
                              }),
                              control: (provided) => ({
                                ...provided,
                                minHeight: "38px",
                                fontSize: "12px",
                                fontWeight: 500,
                              }),
                            }}
                            placeholder={t("Subscription-status")}
                            options={options}
                            onChange={handleStatusChange}
                          />
                        </Col>
                        <Col lg={6} md={6} sm={6}>
                          {/* <Select
                            value={organizationDataValue}
                            placeholder={t("Organization")}
                            options={organization.map((item) => ({
                              value: item.organizationID,
                              label: item.organizationName,
                            }))}
                            onChange={organizerChangeHandler}
                          /> */}
                        </Col>
                      </Row>
                    )}

                    <Row className="mt-3">
                      <Col
                        lg={12}
                        md={12}
                        sm={12}
                        className="d-flex justify-content-end gap-2"
                      >
                        <Button
                          text={t("Reset")}
                          className={"SearchBoxResetButton"}
                          onClick={handleResetButton}
                        />
                        <Button
                          text={t("Search")}
                          className={"SearchButton"}
                          onClick={handleSearchButton}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            ) : null}
          </span>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col
          lg={12}
          md={12}
          sm={12}
          className="d-flex gap-2 justify-content-start"
        >
          <span
            onClick={() => {
              handleClickTab(1);
            }}
            className={
              currentTab === 1
                ? "currenrOrganizationTab_active"
                : "currenrOrganizationTab"
            }
          >
            {t("Current-organizations")}
          </span>
          <span
            onClick={() => {
              handleClickTab(2);
            }}
            className={
              currentTab === 2
                ? "currenrOrganizationTab_active"
                : "currenrOrganizationTab"
            }
          >
            {t("Trial-requests")}
          </span>
          <span
            onClick={() => {
              handleClickTab(3);
            }}
            className={
              currentTab === 3
                ? "currenrOrganizationTab_active"
                : "currenrOrganizationTab"
            }
          >
            {t("Rejected-requests")}
          </span>
        </Col>
      </Row>

      {currentTab === 1 ? (
        <CurrenrOrganization
          setIsScroll={setIsScroll}
          isScroll={isScroll}
          setIsFound={setIsFound}
          isFound={isFound}
          SearchOrganizationName={searchOrganizationData.OrganizationName}
          SearchOrganizationEmail={
            searchOrganizationData.OrganizationContactEmail
          }
          SearchOrganizationDateFrom={
            searchOrganizationData.OrganizationDateFromView
          }
          SearchOrganizationDateTo={
            searchOrganizationData.OrganizationDateToView
          }
          SearchOrganizationStatus={
            searchOrganizationData.OrganizationSubscriptionStatus
          }
        />
      ) : null}
      {currentTab === 2 && (
        <TrailRequest
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          setIsScroll={setIsScroll}
          isScroll={isScroll}
        />
      )}
      {currentTab === 3 && (
        <RejectedRequest
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          setIsScroll={setIsScroll}
          isScroll={isScroll}
        />
      )}


    </>
  );
};

export default ViewOrganization;
